import { useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";
import {
  getBillsHistory,
  type BillHistory,
} from "../api/reportsBillsHistory";

// Синхронен с INVOICE_WINDOW_DAYS в BillOperationsModal — сметки, затворени
// по-рано, вече не подлежат на фактуриране, затова не ги предлагаме.
const INVOICE_WINDOW_DAYS = 5;

// Връща затворени, още нефактурирани сметки, закрити през последните
// INVOICE_WINDOW_DAYS дни — кандидатите за фактуриране от справките.
//
// За разлика от useUninvoicedBills (модул Маркиране) тук НЕ филтрираме по
// отчет: от справките може да се фактурира всяка затворена сметка в прозореца,
// независимо дали е включена в отчет. Преизползваме `/bills/history` —
// session_access на BE решава видимостта (сервитьор vs мениджър).
export const useInvoiceableBills = (options?: { enabled?: boolean }) => {
  return useQuery<BillHistory[]>({
    queryKey: ["bills", "invoiceable-window"],
    queryFn: async () => {
      // Naive local datetime — BE-то прилага per-day time filter, затова
      // подаваме начало на деня (00:00:00), за да е time-условието no-op и да
      // останат всички сметки, затворени на/след (днес − 5 дни).
      const startDate = dayjs()
        .startOf("day")
        .subtract(INVOICE_WINDOW_DAYS, "day")
        .format("YYYY-MM-DD HH:mm:ss");
      const result = await getBillsHistory({
        statuses: ["closed"],
        // Скриваме вече фактурираните (има ред в invoice_bills) — не може да
        // се издаде втора фактура за същата сметка.
        in_invoice: false,
        date_field: "closed_at",
        start_date: startDate,
        sort_by: "closed_at",
        sort_order: "desc",
        page_size: 200,
        // Извиква се от справката "Фактури" — scope-ът идва от правото за
        // справката (view_invoices), не от view_all_users_bills (Маркиране).
        context: "reports",
      });
      return result.items;
    },
    staleTime: 0,
    refetchOnMount: "always",
    enabled: options?.enabled ?? true,
  });
};
